import React from 'react'
import HintPopover from "../../../gd-ui/hint-popover/hint-popover"
import {ControlButtonSize} from "./@types";

export enum ControlButtonType {
    SEARCH              = 'search',

    SETTINGS            = 'settings',
    PREFERENCES         = 'preferences',
    PREFERENCES_SOLID   = 'preferences-solid',

    REMOVE              = 'remove',
    DELETE              = 'delete',
    DELETE_GRAY         = 'delete-gray',
    PREVIEW             = 'preview',
    OPEN_IN_BROWSER     = 'open-in-browser',
    DOWNLOAD            = 'download',
    ATTACHMENT          = 'attachment',
    ADD_SUBITEM         = 'add-subitem',
    ATTACHMENT_ADD      = 'attachment-add',
    EDIT                = 'edit',
    ADD_PAGE            = 'add-page',
    MORE                = 'more',
    COPY                = 'copy',

    PIN                 = 'pin',
    UNPIN               = 'unpin',

    STAR                = 'star',
    UNSTAR              = 'unstar',

    PLUS                = 'plus',
    INFO                = 'info',
    INFO_2              = 'info-2',
    ADD                 = 'add',
    ADD13               = 'add13', // 13px
    CROSS               = 'cross',
    CLOSE               = 'close',
    TOP_PANEL_UP        = 'top-panel-up',
    TOP_PANEL_DOWN      = 'top-panel-down',

    COLLAPSE_RIGHT      = 'collapse-right',

    COLLAPSE            = 'collapse',
    EXPAND              = 'expand',

    COLLAPSE_ALL        = 'collapse-all',   // old icon - white
    EXPAND_ALL          = 'expand-all',

    COLLAPSE_ALL_NEW    = 'collapse-all-new',
    EXPAND_ALL_NEW      = 'expand-all-new',

    ADD_TIME_REPORT     = 'add-time-report',
    OK                  = 'ok',
    HIDE_ITEMS          = 'hide-items',
    SHOW_ITEMS          = 'show-items',
    SORT                = 'sort',
    LINK                = 'link',
    TRAY                = 'tray',
    SIDE_PANEL          = 'side-panel',
    BACK                = 'back',

    COLLAPSE_CONTENT    = 'collapse-content',
    EXPAND_CONTENT      = 'expand-content',

    TIMER_STOP          = 'timer-stop',
    TIMER_PLAY          = 'timer-play',
    TIMER_PAUSE         = 'timer-pause',
    TIMER_CLOSE         = 'timer-close',    // delete timer
    TIMER               = 'timer',          // start timer

    COLOR               = 'color',
    AIM                 = 'aim',
    GROUP               = 'group',

    CHAT                = 'chat',

    RECURRENCE          = 'recurrence',
    EXPENSES            = 'expenses',
}

type Props = {
    id?             : string
    size?           : ControlButtonSize
    hint?           : string
    type?           : ControlButtonType         // yes it is optional becuase someone made it optional in editor ... fck
    iconClass?      : string

    className?      : string
    style?          : any
    children?       : any

    selectedClass?  : string

    isSelected?     : boolean   // makes it blue
    isDisabled?     : boolean

    onMouseEnter?   : callback
    onMouseLeave?   : callback
    onClick?        : {(e:any):void}
}

export default class ControlButtonStandard extends React.Component<Props> {

    private types: any

    constructor(props:Props) {
        super(props)

        this.types = {
            [ControlButtonType.TOP_PANEL_UP]    : {
                iconClass   : "fs-14 i5-collapse-top"
            },
            [ControlButtonType.TOP_PANEL_DOWN]    : {
                iconClass   : "fs-14 i5-expand-top"
            },

            [ControlButtonType.SETTINGS]    : {
                iconClass   : "fs-15 i5-settings"
            },
            [ControlButtonType.PREFERENCES]    : {
                iconClass   : "fs-14 i5-preference-vertical"
            },
            [ControlButtonType.PREFERENCES_SOLID]    : {
                iconClass   : "fs-14 i5-preferences-solid"
            },

            [ControlButtonType.PIN]    : {
                iconClass   : "i5-pin"
            },
            [ControlButtonType.UNPIN]    : {
                iconClass   : "i5-pin-full"
            },
            [ControlButtonType.ADD_SUBITEM] : {
                iconClass   : "fs-14 i5-add-subtask"
            },
            edit    : {
                iconClass   : "fs-14 i5-pen"
            },
            remove: {
                iconClass   : "fs-16 i5-delete-circle-solid red"
            },
            [ControlButtonType.DELETE]: {
                iconClass   : "fs-14 i5-trash-alt ui5-color-red"
            },
            [ControlButtonType.DELETE_GRAY]: {
                iconClass   : "fs-14 i5-trash-alt"
            },
            preview: {
                iconClass   : "fs-14 i5-eye"
            },
            'open-in-browser': {
                iconClass   : "fs-14 i5-open-new-window"
            },
            'download': {
                iconClass   : "fs-14 i5-download"
            },
            'attachment': {
                iconClass   : "fs-14 i5-attachment"
            },
            [ControlButtonType.ATTACHMENT_ADD]    : { iconClass   : "fs-15 i5-attachment" },
            [ControlButtonType.ADD_PAGE]: {
                iconClass   : 'fs-14 i5-add-page'
            },
            [ControlButtonType.MORE]  : {
                iconClass   : 'fs-20 i5-more',  // 24
                iconClass28 : 'fs-20 i5-more'
            },
            [ControlButtonType.INFO]  : {
                iconClass   : 'fs-14 ii5-information'
            },
            [ControlButtonType.INFO_2]  : {
                iconClass   : 'fs-14 i5-info-2'
            },
            'copy'  : {
                iconClass   : 'fs-14 i5-copy'
            },
            [ControlButtonType.PLUS]    : {
                iconClass   : "fs-12 i5-plus"
            },
            [ControlButtonType.ADD]    : {
                iconClass   : "fs-14 i5-plus action"
            },
            [ControlButtonType.ADD13]    : {
                iconClass   : "fs-13 i5-plus"
            },
            cross    : {
                iconClass   : "fs-14 ui5-icon-close ui5-color-system-black action"
            },
            [ControlButtonType.CLOSE]    : {
                iconClass   : "fs-14 ui5-icon-close ui5-color-system-black action"
            },
            [ControlButtonType.ADD_TIME_REPORT]    : {
                iconClass   : "fs-12 i5-plus"
            },
            [ControlButtonType.OK] : {
                iconClass   : 'fs-14 ui5-ico-ok'
            },
            [ControlButtonType.HIDE_ITEMS] : {
                iconClass   : 'fs-14 i5-hide-items'
            },
            [ControlButtonType.SHOW_ITEMS] : {
                iconClass   : 'fs-14 i5-show-items'
            },
            [ControlButtonType.SORT]    : {
                iconClass   : "fs-14 i5-sort"
            },
            [ControlButtonType.LINK] : {
                iconClass   : 'fs-14 i5-copy-link'
            },
            [ControlButtonType.TRAY] : {
                iconClass   : 'fs-14 i5-minimize'
            },
            [ControlButtonType.SIDE_PANEL] : {
                iconClass   : 'fs-14 i5-panel'
            },
            [ControlButtonType.BACK] : {
                iconClass   : 'fs-14 i5-long-arrow-left'
            },
            [ControlButtonType.TIMER_STOP] : {
                iconClass   : 'fs-13 red i5-stop-solid'
            },
            [ControlButtonType.TIMER_PLAY] : {
                iconClass   : 'fs-13 i5-play-solid'
            },
            [ControlButtonType.TIMER_PAUSE] : {
                iconClass   : 'fs-13 i5-pause-solid'
            },
            [ControlButtonType.TIMER_CLOSE] : {
                iconClass   : 'fs-13 i5-trash-alt'
            },

            [ControlButtonType.SEARCH] : {
                iconClass   : 'fs-14 i5-search'
            },

            [ControlButtonType.STAR] : {
                iconClass   : 'fs-14 i5-star-empty'
            },
            [ControlButtonType.UNSTAR] : {
                iconClass   : 'fs-14 i5-star ui5-color-yellow'
            },

            [ControlButtonType.COLLAPSE_RIGHT] : {
                iconClass   : ' fs-9 i5-big-angle-right'
            },

            [ControlButtonType.COLLAPSE] : {
                iconClass   : ' fs-9 i5-big-angle-up'
            },
            [ControlButtonType.EXPAND] : {
                iconClass   : 'i5-big-angle-down fs-9'
            },

            [ControlButtonType.COLLAPSE_CONTENT] : {
                // iconClass   : 'fs-14 i5-long-arrow-up'
                iconClass   : ' fs-10 i5-big-angle-up'
            },
            [ControlButtonType.EXPAND_CONTENT] : {
                // iconClass   : 'fs-14 i5-long-arrow-down'
                iconClass   : 'i5-big-angle-down fs-10'
            },

            [ControlButtonType.COLLAPSE_ALL] : {
                iconClass   : 'i5-collapse fs-12'
            },
            [ControlButtonType.EXPAND_ALL] : {
                iconClass   : 'i5-expand fs-12'
            },

            [ControlButtonType.COLLAPSE_ALL_NEW] : {
                iconClass   : 'i5-collapse-all-new fs-12'
            },
            [ControlButtonType.EXPAND_ALL_NEW] : {
                iconClass   : 'i5-expand-all-new fs-12'
            },



            [ControlButtonType.COLOR] : {
                iconClass   : 'i5-color fs-14'
            },

            [ControlButtonType.AIM] : {
                iconClass   : 'ii5-aim fs-15'
            },
            [ControlButtonType.GROUP]: {
                iconClass   : 'i5-group fs-14'
            },
            [ControlButtonType.CHAT] : {
                iconClass   : 'i5-chat fs-15'
            },
            [ControlButtonType.TIMER] : {
                iconClass   : 'fs-14 i5-timer'
            },
            [ControlButtonType.RECURRENCE] : {
                iconClass   : 'fs-14 i5-recurrence'
            },
            [ControlButtonType.EXPENSES] : {
                iconClass   : 'fs-14 i5-expenses-light'
            }
        }
    }

    render() {

        const size = this.props.size || ControlButtonSize.SIZE_28
        const selectedClass = this.props.selectedClass || 'selected'

        const sizeClass     = "s-"+size

        let iconClass     = Classes(this.props.iconClass)

        if (this.props.type) {
            if (size === ControlButtonSize.SIZE_28 && this.types[this.props.type].iconClass28) {
                iconClass = Classes(this.types[this.props.type].iconClass28, iconClass)
            } else {
                iconClass = Classes(this.types[this.props.type].iconClass, iconClass)
            }
        }

        const buttonClass = Classes("ui5-control-button", iconClass, sizeClass, this.props.className, {
                [selectedClass] : this.props.isSelected,
                'disabled'      : this.props.isDisabled
            }
        )

        return (
            <div id             = {this.props.id}
                 className      = {buttonClass}
                 style          = {this.props.style}
                 onMouseEnter   = {this.props.isDisabled ? undefined : this.props.onMouseEnter}
                 onMouseLeave   = {this.props.isDisabled ? undefined : this.props.onMouseLeave}
                 onClick        = {this.props.isDisabled ? undefined : this.props.onClick}>

                {this.props.hint &&
                    <HintPopover
                        multiline   = {true}
                        hint        = {this.props.hint}
                    />
                }

                {this.props.children}
            </div>
        )
    }
}
